/* eslint-disable no-undef */
/* eslint-disable curly */
/* eslint-disable no-else-return */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-boolean-value */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { observer } from 'mobx-react';
import {
  CardElement,
  Elements,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import pricingDataState from 'Stores/pricingData';
import { STRIPE_KEY } from 'Utils/constants';
import Utils from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import InputTextBox from 'Components/common/InputTextBox';
import ErrorAlertImg from 'Assets/png/error-alert-icon.png';
import IntlPhoneComponent from 'Components/common/IntlPhoneComponent';

const stripePromise = loadStripe(STRIPE_KEY);

const paymentFormObj = {
  address1: '',
  city: '',
  state: '',
  country: '',
  phone: '',
};

const StripeBillingForm = withRouter(
  observer(props => {
    const stripe = useStripe();
    const elements = useElements();

    const formFieldValue = paymentFormObj;

    const [cardErr, setCardErr] = useState('');
    const [inputVal, setInputVal] = useState(formFieldValue);
    const [errMsgAddress, setErrMsgAddress] = useState('');
    const [errMsgCity, setErrMsgCity] = useState('');
    const [errMsgState, setErrMsgState] = useState('');
    const [errMsgCountry, setErrMsgCountry] = useState('');
    const [errMsgPhone, setErrMsgPhone] = useState('');
    const [btnLoader, setBtnLoader] = useState(false);
    const [errUserField, setErrUserField] = useState([]);
    const [apiErrorMsg, setApiErrorMsg] = useState('');

    const updateErrMsgField = id => {
      if (errUserField.length > 0 && errUserField.indexOf(id) !== -1) {
        errUserField.filter(item => item !== id);
        switch (id) {
          case 'address1':
            setErrMsgAddress('');
            break;
          case 'city':
            setErrMsgCity('');
            break;
          case 'state':
            setErrMsgState('');
            break;
          case 'country':
            setErrMsgCountry('');
            break;
          case 'phone':
            setErrMsgPhone('');
            break;
          default:
            break;
        }
      }
    };

    const changeInputVal = (id, data) => {
      const stateObj = { ...inputVal };
      stateObj[id] = data;
      updateErrMsgField(id);
      setInputVal(stateObj);
    };

    const checkPhoneNumberValidation = phoneNumber => {
      let phoneValidation = false;
      if (window.iti !== undefined) {
        if (phoneNumber !== undefined && phoneNumber.length > 0)
          phoneValidation = window.iti.isValidNumber();
      }
      return phoneValidation;
    };

    const validateFormField = async () => {
      const errField = [];
      const { address1, city, state, country, phone } = inputVal;
      if (!Utils.validateStringLength(address1, 1)) {
        setErrMsgAddress('Address is required');
        errField.push('address1');
      }
      if (!Utils.validateStringLength(city, 1)) {
        setErrMsgCity('City is required');
        errField.push('city');
      }
      if (!Utils.validateStringLength(state, 1)) {
        setErrMsgState('State is required');
        errField.push('state');
      }
      if (!Utils.validateStringLength(country, 1)) {
        setErrMsgCountry('Country is required');
        errField.push('country');
      }
      if (!Utils.validateStringLength(phone, 1)) {
        setErrMsgPhone('Phone number is required');
        errField.push('phone');
      } else if (!checkPhoneNumberValidation(phone)) {
        setErrMsgPhone('Enter a valid phone number');
        errField.push('phone');
      }
      setErrUserField(errField);
      return errField;
    };

    const { isAnnualSelected, selectedPlan } = pricingDataState;
    const { price, annualPrice } = selectedPlan;
    let pricingAmount = price;
    if (isAnnualSelected) pricingAmount = annualPrice;

    const paymentSubmit = async event => {
      if (event) event.preventDefault();
      setBtnLoader(true);
      setApiErrorMsg('');
      const errField = await validateFormField();
      if (errField.length < 1) {
        const card = elements.getElement(CardElement);
        const { error, token } = await stripe.createToken(card, inputVal);
        console.log('token ', token);
        console.log('error ', error);
        setCardErr('');
        if (error && Object.keys(error).length > 0) {
          setCardErr(error.message);
          setBtnLoader(false);
          // setTimeout(() => {
          //   setCardErr('');
          // }, 2000);
          Utils.mixpanelTrack(
            CONSTANTS.MX_PRICING_PAGE.LB_PRICING_FORM_STRIPE_TOKEN_ERROR,
            {
              isAnnual: isAnnualSelected,
              userAddressDetails: inputVal,
              stripeError: error.message,
            },
          );
          return false;
        }
        if (token && token.id) {
          const handleCbk = message => {
            setBtnLoader(false);
            setApiErrorMsg(message);
          };
          pricingDataState.paymentSubmit(inputVal, token, handleCbk);
        }
      } else {
        Utils.mixpanelTrack(
          CONSTANTS.MX_PRICING_PAGE.LB_PRICING_FORM_VALIDATION_ERROR,
          {
            isAnnual: isAnnualSelected,
            userAddressDetails: inputVal,
            errFields: errField,
          },
        );
        setBtnLoader(false);
      }
    };

    const processPayment = event => {
      if (event.keyCode === 13) paymentSubmit();
    };

    const setPhoneNumber = value => {
      changeInputVal('phone', value);
    };

    return (
      <form
        onSubmit={paymentSubmit}
        autoComplete="off"
        name="paymentForm"
        className="paymentForm"
        noValidate={true}
      >
        <div className="plan-info-wrap">
          <div className="plan-type-info">
            Adapt {isAnnualSelected ? 'Annual' : 'Monthly'} Subscription
          </div>
          <div className="plan-cost-info">
            You will be charged $
            {Utils.viewsDownloadsNumberFormat(pricingAmount)}
            {isAnnualSelected ? ' / year' : ' / month'}
          </div>
        </div>
        <div className="cardInput">
          <CardElement />
          <span className="errMsgText">{cardErr}</span>
        </div>
        <div className="formDivider">
          <span className="halfCircle right" />
          <span className="dashedLine" />
          <span className="halfCircle left" />
        </div>
        <div className="popupBody">
          <InputTextBox
            name="address1"
            id="address1"
            text="Address"
            type="text"
            value={inputVal.address1}
            change={changeInputVal}
            err={errMsgAddress}
            cbk={e => processPayment(e)}
            readOnly={false}
          />
          <div className="formInputGroup">
            <InputTextBox
              name="city"
              id="city"
              text="City"
              type="text"
              value={inputVal.city}
              change={changeInputVal}
              err={errMsgCity}
              cbk={e => processPayment(e)}
              readOnly={false}
            />
            <InputTextBox
              name="state"
              id="state"
              text="State"
              type="text"
              value={inputVal.state}
              change={changeInputVal}
              err={errMsgState}
              cbk={e => processPayment(e)}
              readOnly={false}
            />
          </div>
          <InputTextBox
            name="country"
            id="country"
            text="Country"
            type="text"
            value={inputVal.country}
            change={changeInputVal}
            err={errMsgCountry}
            cbk={e => processPayment(e)}
            readOnly={false}
          />
          <div className="inputWrapper margin-bot-10">
            <IntlPhoneComponent
              id="phoneNumber"
              phoneNumber={inputVal.phone}
              setPhoneNumber={setPhoneNumber}
            />
            <span
              className="errMsgText"
              dangerouslySetInnerHTML={{
                __html: errMsgPhone || '',
              }}
            />
          </div>
        </div>
        {apiErrorMsg !== '' && (
          <div className="api-error-section">
            <div className="left-section">
              <img
                src={ErrorAlertImg}
                alt="ErrorAlertImg"
                className="error-img"
              />
            </div>
            <div className="right-section">
              <div className="error-title">Payment Failed</div>
              <div className="error-msg">{apiErrorMsg}</div>
            </div>
          </div>
        )}
        <div className="submitSection">
          <button
            type="submit"
            disabled={!stripe}
            className={`animatedButton ${btnLoader ? 'loading' : ''}`}
          >
            {!btnLoader && <span>Purchase Plan</span>}
            {btnLoader && <span className="load-text" />}
          </button>
        </div>
      </form>
    );
  }),
);

const StripeBillingCard = props => {
  return (
    <Elements stripe={stripePromise}>
      <StripeBillingForm {...props} />
    </Elements>
  );
};

export default withRouter(observer(StripeBillingCard));
